import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import { useShop } from "@/context/ShopContext";
import RegionBar from "@/components/RegionBar";
import { Trash2, ShoppingBag, ArrowRight } from "lucide-react";

export default function CartPage() {
  const { cart, updateQty, removeFromCart, subtotal, fmt, linePrice } = useShop();
  const nav = useNavigate();

  return (
    <div data-testid="cart-page" className="bg-[#FAF7F0] text-[#14241C] min-h-[70vh]">
      <RegionBar />
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <h1 className="font-display text-4xl font-bold mb-8">Your Cart</h1>
        {cart.length === 0 ? (
          <div className="text-center py-20" data-testid="cart-empty">
            <ShoppingBag size={40} className="mx-auto text-[#B45B3E] mb-4" />
            <p className="text-[#7a8a80] mb-6">Your cart is empty.</p>
            <Link to="/shop" className="inline-flex items-center gap-2 bg-[#14241C] text-white rounded-full px-7 py-3 font-semibold">Browse the shop <ArrowRight size={16} /></Link>
          </div>
        ) : (
          <>
            <div className="space-y-4">
              {cart.map((c, i) => (
                <div key={i} className="flex items-center gap-4 bg-white border border-[#14241C]/10 rounded-2xl p-4" data-testid={`cart-item-${i}`}>
                  <img src={imgUrl(c.image)} alt={c.name} className="w-20 h-20 object-cover rounded-xl bg-[#F1EFE8]" />
                  <div className="flex-1">
                    <h3 className="font-semibold">{c.name}</h3>
                    <p className="text-xs text-[#7a8a80]">{[c.color, c.size].filter(Boolean).join(" · ")}</p>
                    <p className="text-sm font-bold mt-1">{fmt(linePrice(c))}</p>
                  </div>
                  <div className="flex items-center border border-[#14241C]/20 rounded-lg">
                    <button onClick={() => updateQty(i, c.qty - 1)} className="px-2.5 py-1.5">−</button>
                    <span className="px-2 text-sm">{c.qty}</span>
                    <button onClick={() => updateQty(i, c.qty + 1)} className="px-2.5 py-1.5">+</button>
                  </div>
                  <button onClick={() => removeFromCart(i)} data-testid={`remove-${i}`} className="text-red-600 p-2"><Trash2 size={17} /></button>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-white border border-[#14241C]/10 rounded-2xl p-6">
              <div className="flex justify-between text-lg font-semibold mb-4"><span>Subtotal</span><span data-testid="cart-subtotal">{fmt(subtotal)}</span></div>
              <button onClick={() => nav("/checkout")} data-testid="checkout-btn" className="w-full bg-[#14241C] text-white rounded-full py-4 font-bold hover:bg-[#0e1a13] transition-colors">Proceed to Checkout</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
